var _circle, _path, _path2, _path3, _circle2, _circle3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHydrate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 63,
    viewBox: "0 0 51 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.07,
    cx: 25.3469,
    cy: 25.4778,
    r: 25.3469,
    fill: "#0099FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M50.6939 25.4781C50.6939 39.4768 39.3456 50.825 25.3469 50.825C11.3482 50.825 0 39.4768 0 25.4781C0 25.4781 8.08119 29.7082 16.1299 28.9345C22.9624 28.2777 27.6512 23.7499 37.4443 23.1738C47.2375 22.5977 50.6939 25.4781 50.6939 25.4781Z",
    fill: "#0099FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.6939 25.4779C50.6939 39.4766 39.3456 50.8248 25.3469 50.8248C11.3482 50.8248 0 39.4766 0 25.4779C0 25.4779 5.1846 22.0215 14.4017 23.1736C21.3145 24.3257 25.923 27.2061 35.7161 26.63C45.5093 26.0539 50.6939 25.4779 50.6939 25.4779Z",
    fill: "#0099FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8686 28.6201C36.8686 34.5204 31.9682 39.3035 25.9233 39.3035C19.8784 39.3035 14.978 34.5204 14.978 28.6201C14.978 22.7198 23.6699 11.6523 25.9233 11.6523C28.1767 11.6523 36.8686 22.7198 36.8686 28.6201Z",
    stroke: "#0099FF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 19.5862,
    cy: 41.6072,
    r: 1.15213,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 13.8258,
    cy: 39.3033,
    r: 1.80427,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_563_933)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.796,
    cy: 51.3762,
    rx: 12.6735,
    ry: 2.7551,
    fill: "#0099FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_563_933",
    x: 4.12256,
    y: 40.6211,
    width: 41.3472,
    height: 21.5098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_563_933"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydrate);
export default __webpack_public_path__ + "static/media/Hydrate.c8bce358acef76255c7969396a1e3474.svg";
export { ForwardRef as ReactComponent };